module.exports = __webpack_public_path__ + "img/logo.dbaa6495.png";